module.exports = __webpack_public_path__ + "img/game.c092b6de.png";